let stripePublishableKeyDev: string =  "pk_test_51IYqrXFr7h7OltJtmND8I6BBpxKI560Poym5bKMLIKkZEcmDiZPovKhtfqNds7mqgKbByTXAvHxiU2ZXVUcpVI5O0000KIIa4x";

export  {stripePublishableKeyDev};